import Plan, { PlanAmountsToUpdate, PlanToCreate, PlanToUpdate } from "../models/Plan";
import { Observable } from "rxjs";
import { HttpCommunicator, Container } from "@ivorobioff/shared";

class PlanService {

  private http: HttpCommunicator;

  constructor(container: Container) {
    this.http = container.get('https');
  }

  getAll(accountId?: string): Observable<Plan[]> {
    return this.http.get(`/plans${accountId ? `?accountId=${accountId}` : ''}`);
  }

  async getAllAsync(accountId: string): Promise<Plan[]> {
    return new Promise((resolve, reject) =>
      this.getAll(accountId).subscribe(resolve, reject));
  }

  updateAmounts(id: string, amounts: PlanAmountsToUpdate): Observable<Plan> {
    return this.http.patch('/plans/' + id, amounts);
  }

  async updateAmountsAsync(id: string, amounts: PlanAmountsToUpdate): Promise<Plan> {
    return new Promise((resolve, reject) =>
      this.updateAmounts(id, amounts).subscribe(resolve, reject));
  }

  update(id: string, updates: PlanToUpdate): Observable<Plan> {
    return this.http.patch('/plans/' + id, updates);
  }

  create(plan: PlanToCreate): Observable<Plan> {
    return this.http.post('/plans', plan);
  }

  createAsync(plan: PlanToCreate): Promise<Plan> {
    return new Promise((resolve, reject) =>
      this.create(plan).subscribe(resolve, reject));
  }

  remove(id: string): Observable<any> {
    return this.http.delete('/plans/' + id);
  }

}

export default PlanService